import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRoutes from "./router/AppRoutes";
import { AuthProvider } from "./contexts/authContexts";
import { LayoutProvider } from "./contexts/layoutContext";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
console.log("Cargando la app...");
root.render(
    <AuthProvider>
        <LayoutProvider>
            <AppRoutes />
        </LayoutProvider>
    </AuthProvider>
);

reportWebVitals();
